"use client"

import Script from "next/script"

import { PSEUDO_ID_COOKIE } from "@lib/constants"
import { getSessionCookie } from "@lib/util/get-session-cookie-client"

const GACustomAnalytics = ({ gaId }: { gaId: string }) => {
  const configParams: Record<string, string> = {
    source: "store_front",
  }

  const pseudoId = getSessionCookie(PSEUDO_ID_COOKIE)
  if (pseudoId) {
    configParams.storefront_session_id = pseudoId
  }

  const configParamsStr = JSON.stringify(configParams)

  return (
    <>
      <Script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} />
      <Script id="_next-ga-init">
        {`
          window['dataLayer'] = window['dataLayer'] || [];
          function gtag(){window['dataLayer'].push(arguments);}
          gtag('js', new Date());
          
          gtag('config', '${gaId}', ${configParamsStr});
        `}
      </Script>
    </>
  )
}

export default GACustomAnalytics
